import type { ExposedConfig } from "../api/types";

export type ConfigState = ExposedConfig;

interface ConfigAction {
  type: "SET_CONFIG";
  config: ConfigState;
}

export function setConfig(config: ConfigState) {
  return {
    type: "SET_CONFIG",
    config: config,
  };
}

export function configReducer(
  state: ConfigState = {
    company_router_url: "",
    version: "",
  },
  action: ConfigAction,
) {
  if (action.type === "SET_CONFIG") {
    return Object.assign({}, state, action.config);
  } else {
    return state;
  }
}
